window._CONFIG['apiBaseUrl'] = process.env.VUE_APP_API_BASE_URL;